var map = {
	"./advantages-location.svg": 242,
	"./arrow.svg": 243,
	"./btn-icon.svg": 244,
	"./burger.svg": 245,
	"./camera.svg": 246,
	"./car.svg": 247,
	"./city.svg": 248,
	"./close.svg": 249,
	"./comfort.svg": 250,
	"./cube.svg": 251,
	"./development.svg": 252,
	"./doc.svg": 253,
	"./document.svg": 254,
	"./download.svg": 255,
	"./favorite.svg": 256,
	"./fb.svg": 257,
	"./gold-play.svg": 258,
	"./instagram.svg": 259,
	"./left.svg": 260,
	"./location.svg": 261,
	"./mail.svg": 262,
	"./marker-icon-church.svg": 263,
	"./marker-icon-city.svg": 264,
	"./marker-icon-filicity.svg": 265,
	"./marker-icon-park.svg": 266,
	"./marker-icon-school.svg": 267,
	"./marker-icon-shop.svg": 268,
	"./marker-icon-stadium.svg": 269,
	"./marker-shadow.svg": 270,
	"./marker.svg": 271,
	"./minus.svg": 272,
	"./notamedia.svg": 273,
	"./pedestrian.svg": 274,
	"./phone.svg": 275,
	"./photo.svg": 276,
	"./play-icon.svg": 277,
	"./plus.svg": 278,
	"./resize.svg": 279,
	"./right.svg": 280,
	"./ring.svg": 281,
	"./route.svg": 282,
	"./star.svg": 283,
	"./twitter.svg": 284,
	"./youtube.svg": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;


//////////////////
// WEBPACK FOOTER
// ./i/sprite nonrecursive \.svg$
// module id = 92
// module chunks = 0